
import { Options, Vue } from "vue-class-component";
import EmptyState from "@/app/ui/components/empty-list/index.vue";
import debounce from "lodash/debounce";
import { PosFavoriteController } from "@/app/ui/controllers/PosFavoriteController";
import EditModal from "./components/edit-discount.vue";
import EditDefaultSetting from "./components/default-setting.vue";
import { formatByCountry } from "@/app/infrastructures/misc/Utils";
import { PosFavoriteSubscriberListData } from "@/domain/entities/PosFavorite";
import { AuthAlgoController } from "@/app/ui/controllers/AuthAlgoController";
import formatPrice from "@/app/infrastructures/misc/common-library/v2/FormatPrice";
import { AccountController } from "@/app/ui/controllers/AccountController";

@Options({
  components: {
    EmptyState,
    EditModal,
    EditDefaultSetting
  }
})
export default class MemberTabs extends Vue {
  mounted() {
    PosFavoriteController.initFetchPosFavoriteSubscriber();
  }

  fetchListPosFavoriteSubscriber() {
    PosFavoriteController.fetchListPosFavoriteSubscriber();
  }
  get isLoading() {
    return PosFavoriteController.isLoading || AuthAlgoController.isLoading;
  }

  get errorCause() {
    return PosFavoriteController.errorCause;
  }

  get isError() {
    return PosFavoriteController.isError;
  }

  get isFirstRequest() {
    return PosFavoriteController.isFirstRequest;
  }

  // Table
  get pagination() {
    return PosFavoriteController.posFavoriteSubscriber.pagination;
  }

  get columns() {
    return [
      {
        name: this.$t("posFavourite.memberTabs.tableHeaders.no"),
        styleHead: "w-16 text-left whitespace-no-wrap",
        render: (item: PosFavoriteSubscriberListData, index: number) => {
          return `<div class='text-left text-black-lp-300 flex justify-center'>${index +
            1}</div>`;
        }
      },
      {
        name: this.$t("posFavourite.memberTabs.tableHeaders.memberName"),
        styleHead: "w-56 text-left whitespace-no-wrap",
        render: (item: PosFavoriteSubscriberListData) => {
          return `<p class="overflow-ellipsis text-black-lp-300 break-all">${item.fullname}</p>`;
        }
      },
      {
        name: this.$t("posFavourite.memberTabs.tableHeaders.address"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: () => {
          return `<div class="overflow-ellipsis text-black-lp-300">-</div>`;
        }
      },
      {
        name: this.$t("posFavourite.memberTabs.tableHeaders.phone"),
        styleHead: "w-40 text-left whitespace-no-wrap",
        render: (item: PosFavoriteSubscriberListData) => {
          return `<div class='flex text-black-lp-300'>${item.phoneNumber}</div>`;
        }
      },
      {
        name: this.$t("posFavourite.memberTabs.tableHeaders.discount"),
        styleHead: "w-24 text-left whitespace-no-wrap",
        render: (item: PosFavoriteSubscriberListData) => {
          return `<span class="text-black-lp-300" data-testid="pos-favorite-member-cell-discount">${formatByCountry(item.discount, { type: "percentage" })}</span>`;
        }
      },
      {
        name: this.$t("posFavourite.memberTabs.tableHeaders.subscriptionDate"),
        styleHead: "w-52 text-left whitespace-no-wrap",
        render: () => {
          return `<div class="overflow-ellipsis text-left">-</div>
          <div class="flex text-gray-lp-500">-</div>`;
        }
      },
      {
        name: this.$t("posFavourite.memberTabs.tableHeaders.updatedAt"),
        styleHead: "w-48 text-left whitespace-no-wrap",
        render: () => {
          return `<div class='flex text-black-lp-300'>-</div>
          <div class='flex text-gray-lp-500'>-</div>`;
        }
      },
      {
        name: this.$t("posFavourite.memberTabs.tableHeaders.spending"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: PosFavoriteSubscriberListData) => {
          return `<div class='flex text-black-lp-300' data-testid="pos-favorite-member-cell-spending">${formatByCountry(item.spending, { type: "money" })}</div>`;
        }
      },
      {
        name: this.$t("posFavourite.memberTabs.tableHeaders.action"),
        key: "button_column",
        styleHead: "w-32 text-left",
        styleButton: (item: any, index: any) => {
          return {
            class: "w-full bg-white",
            icon: "union-edit",
            outline: true,
            color: "white",
            clickFunction: () => this.setModalShow(item, index)
          };
        }
      }
    ];
  }

  get members() {
    return PosFavoriteController.posFavoriteSubscriber.data;
  }

  // handle Edit Modal
  get isModalShow() {
    return PosFavoriteController.isShowModal;
  }

  get accountCurrency(): "IDR" | "MYR" {
    return (
      (AccountController.accountData?.accountCurrency as "IDR" | "MYR") ?? "IDR"
    );
  }
  setModalShow(item: any, index: any) {
    PosFavoriteController.setShowModal(true);
    PosFavoriteController.setIndexMembers(index);
    PosFavoriteController.setDiscount(item.discount);
  }

  setCloseModalShow() {
    PosFavoriteController.setShowModal(false);
  }

  // search filter
  searchValue = "";
  onSearch = debounce((val) => {
    this.searchValue = val;
    if (val.length >= 3 && val !== "") {
      PosFavoriteController.setSearch(val);
      this.fetchListPosFavoriteSubscriber();
    }
  }, 250);
  clearSearch() {
    this.searchValue = "";
    PosFavoriteController.setSearch("");
    this.fetchListPosFavoriteSubscriber();
  }

  // Update
  isUpdateDefaultSetting = false;
  setUpdateDefaultSetting(value: boolean) {
    this.isUpdateDefaultSetting = value;
  }
}
